import routeNames from './route-names'
import BaseRouterView from '@/components/base/BaseRouterView'

const Contracts = () => import(/* webpackChunkName: "contracts" */'@/views/contract/Contracts')
const Contract = () => import(/* webpackChunkName: "contracts" */'@/views/contract/contract/Contract')
const Overview = () => import(/* webpackChunkName: "contracts" */'@/views/contract/contract/Overview')

function props (route) {
    return {
        contractId: parseInt(route.params.contractId)
    }
}

export default {
    path: '/customers/contracts',
    component: BaseRouterView,
    children: [
        {
            path: '/',
            name: routeNames.CONTRACTS,
            meta: {title: 'Contracts'},
            component: Contracts
        },
        {
            path: ':contractId',
            component: Contract,
            props,
            children: [
                {
                    path: '/',
                    name: routeNames.CONTRACT,
                    meta: {title: 'Contract'},
                    component: Overview,
                    props
                }
            ]
        }
    ]
}
